<template>
    <div class="layout-topbar">
        <div class="layout-topbar-wrapper">
            <div class="layout-topbar-left">
                <a tabindex="0" class="menu-button" @click="onMenuButtonClick">
                    <i class="pi pi-bars"></i>
                </a>
                <router-link id="logo-link" class="layout-topbar-logo" to="/">
                    <img :src="'layout/images/' + (topbarTheme === 'dark' ? 'logoWhite' : 'logoBlack') + '.svg'" alt="giro da sorte"/>
                </router-link>
            </div>

            <AppMenu :layoutMode="layoutMode" :sidebarActive="sidebarActive" :sidebarStatic="sidebarStatic" :menuActive="menuActive" :mobileMenuActive="mobileMenuActive" 
                @sidebar-mouse-leave="onSidebarMouseLeave" @sidebar-mouse-over="onSidebarMouseOver" @toggle-menu="onToggleMenu" 
                @menu-click="onMenuClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick" />

            <div class="layout-topbar-right">
                <ul class="layout-topbar-actions">
                    <li ref="profile" class="topbar-item user-profile" :class="{'active-topmenuitem fadeInDown': topbarUserMenuActive}">
                        <span style="font-weight: bold; color: #464df2;">
                            {{ this.loggedUser().id ? this.loggedUser().username.toUpperCase() : '' }}
                        </span>
                        <a @click="onTopbarUserMenuClick">
                            <i class="pi pi-user" style="font-size: 1.6rem"/>
                        </a>
                        <ul class="fadeInDown">
                            <li @click="$router.push({name: 'profile'})">
                                <span>Perfil</span>
                            </li>
                            <li @click="onLogoutClick()">
                                <span>Sair</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import AppMenu from './AppMenu';
export default {
    name: "AppTopbar",
    emits: ["menu-click", "menuitem-click", "root-menuitem-click", "menu-button-click", "toggle-menu",
        "sidebar-mouse-over", "sidebar-mouse-leave", "topbar-usermenu-click", "logout-click"],
    props: {
        topbarItemClick: Boolean,
        topbarUserMenuActive: Boolean,
        topbarUserMenuClick: Boolean,
        activeTopbarItem: String,
        sidebarActive: Boolean,
        sidebarStatic: Boolean,
        layoutMode: String,
        topbarTheme: String,
        menuActive: Boolean,
        mobileMenuActive: Boolean
    },

    data: () => ({
       
    }),

    mounted() {

    },

    unmounted() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    },
    
    methods: {

        onLogoutClick(event) {
            this.$emit("logout-click", event);
        },

        onMenuClick(event) {
            this.$emit("menu-click", event);
        },
        
        onMenuItemClick(event) {
            this.$emit("menuitem-click", event);
        },

		onRootMenuItemClick(event) {
			this.$emit("root-menuitem-click", event);
		},

        onMenuButtonClick(event) {
            this.$emit("menu-button-click", event);
        },

        onToggleMenu(event) {
            this.$emit("toggle-menu", event);
        },

        onTopbarUserMenuClick(event) {
            this.$emit("topbar-usermenu-click", event)
        },

        onSidebarMouseOver() {
            this.$emit("sidebar-mouse-over");
        },

        onSidebarMouseLeave() {
            this.$emit("sidebar-mouse-leave");
        }, 
    }, 
    components: { 
        AppMenu
    }
};
</script>

<style scoped>
    .btn-logout {
        width: 100%;
        text-align: inherit;
        padding: 10px 20px;
        background: transparent;
        border: none;
        font-weight: 500;
        cursor: pointer;
    }
</style>